import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import cx from 'classnames';
import Icon from 'components/Icon';
import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from './styles.module.scss';

const BalloonLayout = (ymaps) =>
	ymaps.templateLayoutFactory.createClass(
		renderToStaticMarkup(
			<div className={styles.Balloon}>
				[if properties.thumbnailImg]
				<div className={styles.Balloon__ImageWrapper}>
					<img
						className={styles.Balloon__Image}
						src="{{ properties.thumbnailImg }}"
						alt=""
						loading="lazy"
					/>
				</div>
				[endif]
				<div className={styles.Balloon__Body}>
					<div className={styles.Balloon__BodyHeader}>
						[if properties.url]
						<a
							className={styles.Balloon__InstituteLink}
							href="{{ properties.url }}"
						>
							{'{{ properties.title }}'}
						</a>
						[else]
						<span className={styles.Balloon__InstituteTitle}>
							{'{{ properties.title }}'}
						</span>
						[endif]
						<button className={styles.Balloon__CloseButton} type="button">
							<Icon
								icon="close"
								className={cx(
									styles.Balloon__CloseIcon,
									PVI_NO_STYLES_CLASSNAME
								)}
								useClassName={PVI_NO_STYLES_CLASSNAME}
							/>
						</button>
					</div>
					<span className={styles.Balloon__InstituteLocation}>
						{'{{ properties.address }}'}
					</span>
				</div>
				<div className={styles.Balloon__Triangle} />
			</div>
		),
		{
			build() {
				this.constructor.superclass.build.call(this);

				const _closeElement = document.querySelector(
					`.${styles.Balloon__CloseButton}`
				);
				const _element = document.querySelector(`.${styles.Balloon}`);
				_closeElement.addEventListener('click', this.onCloseClick.bind(this));
				this._closeElement = _closeElement;
				this._element = _element;
			},
			onCloseClick(event) {
				event.preventDefault();
				this.events.fire('userclose');
			},
			clear() {
				this._closeElement.removeEventListener(
					'click',
					this.onCloseClick.bind(this)
				);
				this.constructor.superclass.clear.call(this);
			},
			getShape() {
				if (!this._isElement(this._element)) {
					return BalloonLayout(ymaps).superclass.getShape.call(this);
				}
				const position = {
					top: this._element.offsetTop,
					left: this._element.offsetLeft
				};

				return new ymaps.shape.Rectangle(
					new ymaps.geometry.pixel.Rectangle([
						[position.left, position.top],
						[
							position.left + this._element.offsetWidth,
							position.top +
								this._element.offsetHeight +
								this._element.querySelector(`.${styles.Balloon__Triangle}`)
									.offsetHeight
						]
					])
				);
			},
			_isElement(element) {
				return element && element.querySelector(`.${styles.Balloon__Triangle}`);
			}
		}
	);

export default BalloonLayout;
